import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeHoppPricingPlans} from "./doppe-action-type-hopp-pricing-plans";

export const doppeActionTypeHoppPricingPlansViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppPricingPlans, {
    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppPricingPlansWidget: (await import(
                './doppe-action-type-hopp-pricing-plans-widget/doppe-action-type-hopp-pricing-plans-widget'
            )).DoppeActionTypeHoppPricingPlansWidget
        }
    },
    renderWidget: (renderProps, viewerComponents) => {
        const {
            DoppeActionTypeHoppPricingPlansWidget
        } = viewerComponents;
        return (
            <DoppeActionTypeHoppPricingPlansWidget
                {...renderProps}
            />
        );
    }
}); 